// Menu mobilne w nagłówku: przycisk otwiera panel, Esc / klik obok / wybór linku zamyka.
export function initMenu() {
    const header = document.querySelector("[data-cc-header]");
    const toggle = header?.querySelector("[data-cc-menu-toggle]");
    const nav = header?.querySelector("#cc-nav");
    if (!header || !toggle || !nav) {
        return;
    }

    const isOpen = () => header.classList.contains("is-open");
    const setOpen = (open) => {
        header.classList.toggle("is-open", open);
        toggle.setAttribute("aria-expanded", String(open));
        toggle.setAttribute("aria-label", open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
    };

    toggle.addEventListener("click", () => setOpen(!isOpen()));

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && isOpen()) {
            setOpen(false);
            toggle.focus();
        }
    });

    document.addEventListener("click", (event) => {
        if (isOpen() && !header.contains(event.target)) {
            setOpen(false);
        }
    });

    nav.addEventListener("click", (event) => {
        if (event.target.closest("a")) {
            setOpen(false);
        }
    });

    window.matchMedia("(min-width: 1120px)").addEventListener("change", (event) => {
        if (event.matches) {
            setOpen(false);
        }
    });
}
